var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.633,
    height: 15.452,
    viewBox: "0 0 21.633 15.452",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26",
    "data-name": "Layer 26",
    transform: "translate(-2 -6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4777",
    "data-name": "Path 4777",
    d: "M21.315,21.452h-17A2.318,2.318,0,0,1,2,19.134V8.318A2.318,2.318,0,0,1,4.318,6h17a2.318,2.318,0,0,1,2.318,2.318V19.134A2.318,2.318,0,0,1,21.315,21.452Zm-17-13.907a.773.773,0,0,0-.773.773V19.134a.773.773,0,0,0,.773.773h17a.773.773,0,0,0,.773-.773V8.318a.773.773,0,0,0-.773-.773Zm7.262,9.271a.773.773,0,0,0-.773-.773H7.717a.464.464,0,0,1-.464-.464V11.872a.464.464,0,0,1,.464-.464h3.09a.773.773,0,1,0,0-1.545H7.717a2.016,2.016,0,0,0-2.009,2.009V15.58a2.016,2.016,0,0,0,2.009,2.009h3.09A.773.773,0,0,0,11.58,16.816Zm8.344,0a.773.773,0,0,0-.773-.773h-3.09a.471.471,0,0,1-.464-.464V11.872a.471.471,0,0,1,.464-.464h3.09a.773.773,0,0,0,0-1.545h-3.09a2.016,2.016,0,0,0-2.009,2.009V15.58a2.016,2.016,0,0,0,2.009,2.009h3.09A.773.773,0,0,0,19.924,16.816Z",
    fill: "#fafafa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.25bc3e4d7de766f0bca07354987e6fb6.svg";
export { ForwardRef as ReactComponent };